import React, {useEffect} from 'react';
import {ThemeProvider} from 'styled-components';
import {theme} from './styles/theme';

import {Helmet, HelmetProvider} from "react-helmet-async";
import {Header} from "./components/Header";
import {Hero} from "./components/Hero";
import {HowItWorks} from "./components/HowItWorks";
import { Features } from './components/Features';
import { SeeInAction } from './components/SeeInAction';
import {PricingPlans} from "./components/PricingPlans";
import {Testimonials} from "./components/Testimonials";
import {FAQ} from "./components/FAQ";
import {Contact} from "./components/Contact";
import {CTA} from "./components/CTA";
import {Footer} from "./components/Footer";

export function HomePage() {
    useEffect(() => {
        document.title = "SAI - Live Multilingual Translation";

        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                const targetId = anchor.getAttribute('href')?.substring(1);
                if (!targetId) return;

                const targetElement = document.getElementById(targetId);
                if (!targetElement) return;

                window.scrollTo({
                    top: targetElement.offsetTop - 80,
                    behavior: 'smooth'
                });
            });
        });

        return () => {
            document.querySelectorAll('a[href^="#"]').forEach(anchor => {
                anchor.removeEventListener('click', () => {});
            });
        };
    }, [])

    return (
        <HelmetProvider>
            <ThemeProvider theme={theme}>
                <Helmet>
                    <script src="https://web.cmp.usercentrics.eu/modules/autoblocker.js"></script>
                    <script id="usercentrics-cmp" src="https://web.cmp.usercentrics.eu/ui/loader.js"
                            data-settings-id="4z_e38fljKU4hf" async></script>

                    <script type="text/javascript">
                        {`var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
                        (function(){
                        var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
                        s1.async=true;
                        s1.src='https://embed.tawk.to/6807a829313aa5191870e1ee/1ipeuhpkk';
                        s1.charset='UTF-8';
                        s1.setAttribute('crossorigin','*');
                        s0.parentNode.insertBefore(s1,s0);
                        })();`}
                    </script>
                </Helmet>
                <div className="min-h-screen bg-white">
                    <Header />
                    <main>
                        <Hero />
                        <SeeInAction />
                        <Features />
                        <HowItWorks />
                        <PricingPlans />
                        {/*<Testimonials />*/}
                        <FAQ />
                        <Contact />
                        <CTA />
                    </main>
                    <Footer />
                </div>
            </ThemeProvider>
        </HelmetProvider>
    );
}
